import { Avatar, AvatarProps } from '@spotify/confidence-core-react';
import { IdentityRefFragment } from '@spotify/confidence-graphql';

import { identityKind } from '../../utils';
import { getIdentityKindIcon } from './identityKindIcon';

export type IdentityAvatarProps = Omit<AvatarProps, 'children'> & {
  identityRef?: IdentityRefFragment | null;
};

export const IdentityAvatarBase = (
  props: IdentityAvatarProps & { avatarSrc?: string },
) => {
  const { identityRef, avatarSrc, ...avatarProps } = props;

  const kind = identityRef?.name ? identityKind(identityRef.name) : undefined;

  return (
    <Avatar
      {...(kind === 'user' ? { 'data-csr-block': true } : {})}
      title={identityRef?.displayName ?? undefined}
      {...avatarProps}
      src={avatarSrc}
    >
      {getIdentityKindIcon(kind)}
    </Avatar>
  );
};
